import {PageForm} from '/src/layouts/page';
import { useLocation } from 'react-router-dom';
import BotForm from '/src/features/bot/components/BotForm/BotForm';
import QuotePart from '/src/components/quote/QuotePart';

function BotFormPage() {
    const location = useLocation();
    var data = null;
    var type = null;
    if (location.state !=null) {
        data =  location.state.data;
        type = location.state.type
    }

    return (
        <PageForm>
                <BotForm data={data} type={type}/>
                <QuotePart/>
        </PageForm>

    );
}
export default BotFormPage;